module.exports = __webpack_public_path__ + "img/DoneOutlineOutlined.346dbd0d.svg";